import { useCallback, useReducer } from "react";

const reducer = (state, action) => {
  switch (action.type) {
    case "start":
      return { ...state, isLoading: true, loadingError: null };
    case "finish":
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload ?? null,
      };
    default:
      return state;
  }
};

const useDataLoading = () => {
  const start = useCallback(() => dispatch({ type: "start" }), []);
  const stop = useCallback(
    (error = null) => dispatch({ type: "finish", payload: error }),
    []
  );

  const [state, dispatch] = useReducer(reducer, {
    isLoading: true,
    loadingError: null,
    start: start,
    stop: stop,
  });

  return state;
};

export default useDataLoading;
